import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { todayDateOnlyInTz } from '@/shared/utils/dateUtils';
import { tasksService } from '../api/tasks.service';
import { TASK_KEYS } from './queryKeys';

export function useBoardActivitySummary(projectId: string, boardId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);
  const today = todayDateOnlyInTz();

  const { data, isLoading, isError } = useQuery({
    queryKey: TASK_KEYS.boardActivitySummary(orgId ?? '', boardId, today, today),
    queryFn: ({ signal }) =>
      tasksService.getBoardActivitySummary(projectId, boardId, { From: today, To: today }, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!projectId && !!boardId,
  });

  return {
    summary: data ?? null,
    isLoading,
    isError,
  };
}
